import { render, staticRenderFns } from "./chatModal.vue?vue&type=template&id=4c866546&scoped=true&"
import script from "./chatModal.vue?vue&type=script&lang=js&"
export * from "./chatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c866546",
  null
  
)

export default component.exports